import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

export const GAMLS_RULE = { test: (v) => /^[A-Z]\d{11}$/.test(String(v || "").trim().toUpperCase()), text: "1 letter + 11 numbers, e.g. A12345678901", max: 12 };
export const gamlsInvalid = (v) => !!String(v || "").trim() && !GAMLS_RULE.test(v);

export const RuleHint = ({ rule, value, testId }) => {
  if (!rule) { return null; }
  const bad = !!String(value || "").trim() && !rule.test(value);
  return <p className={`mt-1 text-xs ${bad ? "text-[#B30000] font-semibold" : "text-gray-500"}`} data-testid={`${testId}-rule`}>{bad ? `Wrong format: ${rule.text}` : rule.text}</p>;
};

export const IdField = ({ label, value, onChange, none, setNone, placeholder, testId, noneLabel, inputClass = "h-11", rule }) => (
  <div>
    <Input value={none ? "" : value} onChange={(e) => onChange(e.target.value)} disabled={none} placeholder={none ? "Not provided" : placeholder || (rule && "A12345678901")}
      maxLength={rule?.max} aria-label={label} aria-invalid={!none && rule ? gamlsInvalid(value) : undefined} className={`${inputClass} font-mono uppercase placeholder:normal-case`} data-testid={`${testId}-input`} />
    <label className="mt-2 flex items-center gap-2 text-xs text-gray-600 cursor-pointer select-none">
      <Checkbox checked={none} onCheckedChange={(c) => { setNone(!!c); if (c) onChange(""); }} data-testid={`${testId}-none`} />
      {noneLabel}
    </label>
    {!none && <RuleHint rule={rule} value={value} testId={testId} />}
  </div>
);
